var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Benin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24H19v19.344C20.601,43.757,22.27,44,24,44C35.046,44,44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M44,24c0-11.046-8.954-20-20-20c-1.73,0-3.399,0.243-5,0.656V24H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#43a047",
    d: "M19,4.656C10.379,6.879,4,14.684,4,24c0,9.316,6.379,17.121,15,19.344V24V4.656z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Benin);
export default __webpack_public_path__ + "static/media/icons8-benin.d7a7d557a3a50819c1db3cc82c846764.svg";
export { ForwardRef as ReactComponent };